export const SUPPORTS_ARRAY_PROTOTYPE_REDUCE_RIGHT = "reduceRight" in Array.prototype;
